export default __webpack_public_path__ + "images/referrals-onboarding-step-2.dbc3c0b7f330f73aec015b96c4883bee.svg";